export enum PriceFreezeIconNameEnum {
  PriceFreezeSnowFlake = "PriceFreezeSnowFlake",
  PriceFreezePriceSame = "PriceFreezePriceSame",
  PriceFreezePriceGoesUp = "PriceFreezePriceGoesUp",
  PriceFreezePriceGoesDown = "PriceFreezePriceGoesDown",
  PriceFreezeCheckMark = "PriceFreezeCheckMark",
  PriceFreezeRefund = "PriceFreezeRefund",
}
